import React from 'react';
import './Legal.css';

export default function TermsOfService() {
    return (
        <div className="legal-page animate-in">
            <header className="legal-header">
                <h1>Términos de Servicio</h1>
                <p className="subtitle">Última actualización: Abril 2026</p>
            </header>
            
            <div className="legal-content glass-card">
                <section>
                    <h2>1. Aceptación de los Términos</h2>
                    <p>Al acceder y utilizar ALINEA, usted acepta cumplir con estos términos diseñados para fomentar la maestría industrial y el bienestar organizacional.</p>
                </section>

                <section>
                    <h2>2. Uso de la Plataforma</h2>
                    <p>
                        ALINEA es una herramienta de acompañamiento organizacional y monitoreo operativo
                        preventivo. El usuario se compromete a usar la plataforma de buena fe para su
                        jornada y cuidado colectivo. ALINEA no evalúa veracidad personal ni realiza
                        diagnóstico médico o psicológico; las lecturas son señales e hipótesis de apoyo
                        al juicio humano.
                    </p>
                </section>

                <section>
                    <h2>3. Propiedad Intelectual</h2>
                    <p>La metodología EPA (Escucha, Procesa, Ajusta) y el diseño de la plataforma son propiedad exclusiva de ALINEA S.A.S.</p>
                </section>

                <section>
                    <h2>4. Notificaciones</h2>
                    <p>Usted acepta recibir alertas operativas y mensajes de retroalimentación basados en su perfil de personalidad y datos de desempeño.</p>
                </section>
            </div>
            
            <div className="legal-footer">
                <button onClick={() => window.history.back()} className="btn btn-primary">Volver</button>
            </div>
        </div>
    );
}
